import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';
import OutletCard from './OutletCard';

const VirtualizedOutletList = ({ outlets, onTypeChange, searchQuery }) => {
  const listRef = useRef();
  const itemSize = 60; // Height of each item in pixels
  const listHeight = Math.min(500, outlets.length * itemSize); // Max height of 500px

  // Reset list scroll position when search query changes
  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTo(0);
    }
  }, [searchQuery]);

  const OutletRow = useCallback(
    ({ index, style }) => {
      const outlet = outlets[index];
      return (
        <div style={style}>
          <OutletCard outlet={outlet} onTypeChange={onTypeChange} />
        </div>
      );
    },
    [outlets, onTypeChange]
  );

  OutletRow.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  return (
    <List ref={listRef} height={listHeight} width="100%" itemCount={outlets.length} itemSize={itemSize}>
      {OutletRow}
    </List>
  );
};

VirtualizedOutletList.propTypes = {
  outlets: PropTypes.array.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
};

export default VirtualizedOutletList;
